import ContentTypeComments from './ContentTypeComments';

export default ContentTypeComments;